<template>
  <el-form :model="formList" ref="formList" label-width="140px" label-position="left" class="form">
    <el-form-item
      v-for="(item, index) in editItem"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      :rules="[{ required: item.required, message: item.placeholder, trigger: 'blur' }]"
    >
      <blue-title class="form-title" v-if="item.type === 'title'">{{ item.title }}</blue-title>
      <div class="box_row">
        <div class="form-box">
          <!-- 文本 -->
          <span v-if="item.type == ''">{{ formList[item.prop] }}</span>
          <!-- 输入框/多行文本 -->
          <el-input
            v-else-if="item.type == 'text' || item.type == 'textarea'"
            :type="item.type"
            v-model="formList[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <!-- 上传 -->
          <div v-else-if="item.type === 'upload'">
            <el-upload
              class="avatar-uploader"
              :action="$configUrl.uploadUrl"
              :show-file-list="false"
              :on-success="
                (response, file, fileList) => {
                  return handleAvatarSuccess(file, fileList, item);
                }
              "
              :before-upload="beforeAvatarUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <span>上传</span>
            </el-upload>
            <img v-if="formList[item.prop]" :src="formList[item.prop]" class="avatar" />
          </div>
          <!-- 单选 -->
          <div v-else-if="item.type === 'radio'">
            <el-radio-group v-model="formList[item.prop]">
              <el-radio label="1">三证未合一</el-radio>
              <el-radio label="2">三证合一</el-radio>
            </el-radio-group>
          </div>
          <!-- 日期 -->
          <div v-else-if="item.type === 'date'" class="box_row form-date">
            <el-date-picker
              v-model="formList[item.prop]"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-checkbox v-model="formList[item.prop]">长期</el-checkbox>
          </div>

          <!-- 下拉框 -->
          <el-select v-else-if="item.type === 'select'" v-model="formList[item.prop]" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :placeholder="item.placeholder"
            >
            </el-option>
          </el-select>
          <!-- 修改按钮 -->
          <span class="form-edit" v-if="item.edit" @click="editCompanyName">修改</span>
        </div>
        <!-- 提示信息 -->
        <span :class="item.color ? 'form-date-tip form-tip' : 'form-tip'">{{ item.info }}</span>
      </div>
    </el-form-item>
    <el-form-item class="footer">
      <el-button type="primary" @click="onSubmit('formList')">提交修改</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { companyEdit } from '@account/static/data.js';
export default {
  computed: {
    editItem() {
      return companyEdit.get(this.$route.name);
    },
  },
  data() {
    return {
      companyEdit,
      imageUrl: '',
      options: [
        {
          value: '选项1',
          label: '黄金糕',
        },
        {
          value: '选项2',
          label: '双皮奶',
        },
        {
          value: '选项3',
          label: '蚵仔煎',
        },
        {
          value: '选项4',
          label: '龙须面',
        },
        {
          value: '选项5',
          label: '北京烤鸭',
        },
      ],
      // 表单信息
      formList: {
        companyName: '北京佰医汇医疗信息技术有限公司',
        industrialPhoto: '',
        businessLicense: '',
        businessLicenseType: '1',
        businessLicenseNumber: '',
        address: '',
        businessScope: '',
        date: [],
        certificateHolderType: '企业法人',
        certificateType: '',
        cardFront: '',
        cardBack: '',
        certificateName: '',
        certificateNumber: '',
        certificateValidity: '',
      },
    };
  },
  methods: {
    handleAvatarSuccess(file, fileList, item) {
      console.log(file, fileList, item);
      this.formList[item.prop] = file.response.data.url;
      console.log(this.formList[item.prop]);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 提交
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.formList);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消
    cancel() {
      this.$router.back(1);
    },
    // 修改公司名称
    editCompanyName() {
      this.$router.push({ name: 'account/enterprise/edit/name' });
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  padding: 30px 33px;
}
.avatar-uploader {
  width: 79px;
  height: 38px;
  text-align: center;
  border: 1px solid #4359b7;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  span {
    color: #4359b7;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #4359b7;
}
.avatar-uploader-icon {
  font-size: 14px;
  color: #4359b7;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 160px;
  display: block;
  margin-top: 20px;
}
.el-input,
.el-textarea,
.el-date-editor {
  width: 300px;
}
.el-select {
  width: 133px;
}
.form-box {
  width: 43%;
  flex-shrink: 0;
}
.form-tip {
  color: #999;
  line-height: 20px;
  margin-top: 10px;
}
.form-date {
  width: 410px;
  .el-checkbox {
    padding: 0 40px 0 16px;
  }
}
.form-date-tip {
  color: #43aab7;
  margin-left: 50px;
}
.form-title {
  margin-left: -150px;
}
.footer {
  margin: 36px 0 40px -140px;
}
.form-edit {
  padding-left: 20px;
  color: #4359b7;
  cursor: pointer;
}
</style>
